import script from "./MessageSendDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageSendDialog.vue?vue&type=script&setup=true&lang=js"

import "./MessageSendDialog.vue?vue&type=style&index=0&id=39423c72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39423c72"]])

export default __exports__